import Vue from "vue";
import listingCarousel from "./listingCarousel.vue";

export function load() {
    const selector = "listing-carousel-component";
  // Is the custom Vue root element in the DOM?

  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
          createElement(listingCarousel, {
        props: {
          ...window[selector]
        }
      })
  }).$mount(selector);
}
